import { render } from "./ProviderView.vue?vue&type=template&id=07fd78c3&scoped=true"
import script from "./ProviderView.vue?vue&type=script&lang=js"
export * from "./ProviderView.vue?vue&type=script&lang=js"

import "./ProviderView.vue?vue&type=style&index=0&id=07fd78c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fd78c3"]])

export default __exports__